
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStarWeavers from '../../hooks/useStarWeavers';
import LoadingSpinner from '../LoadingSpinner';

const StarWeavers = ({ dreamWeaveId, nexusId }) => {
    const { t } = useTranslation();
    const { weavers, loading, error } = useStarWeavers(dreamWeaveId, nexusId);

    if (loading) {
        return <LoadingSpinner message={t('starWeavers.loading')} />;
    }

    if (error) {
        return <p className="text-red-500">{t('starWeavers.error')}</p>;
    }

    return (
        <div className="bg-gray-900/50 backdrop-blur-sm p-4 rounded-lg border border-cyan-500/20">
            <h2 className="text-xl font-bold text-cyan-300 mb-4 text-center">{t('starWeavers.title')}</h2>
            <ul>
                {weavers.map((weaver, index) => (
                    <li key={weaver.id} className="flex items-center justify-between p-2 bg-gray-800/70 rounded mb-2 transition-all hover:bg-gray-700/90">
                        <div className="flex items-center">
                            <span className="text-lg font-bold text-cyan-400 mr-3">#{index + 1}</span>
                            <img src={weaver.photoURL} alt={weaver.displayName} className="w-10 h-10 rounded-full mr-3" />
                            <span className="font-semibold">{weaver.displayName}</span>
                        </div>
                        <span className="text-yellow-400 font-mono">{weaver.contributionCount} {t('starWeavers.souls')}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default StarWeavers;
